import { varAlpha } from 'minimal-shared/utils';
import { useBoolean } from 'minimal-shared/hooks';

import { useTheme } from '@mui/material/styles';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { TableRow, Collapse, TableCell, IconButton } from '@mui/material';

import { formatDollarAmount } from '../../../../../shared/utils/policyUtils';
import UnitStatExposuresNestedTable from './unit-stat-exposures-nested-table';

import type { USRExposuresTableRow } from '../types';

export default function UnitStatExposuresRow({
  row,
  rowIndex,
}: {
  row: USRExposuresTableRow;
  rowIndex: number;
}) {
  const open = useBoolean();
  const theme = useTheme();

  return (
    <>
      <TableRow
        sx={{ '& > *': { borderBottom: 'unset' } }}
        data-testid={`exposures-row-${rowIndex}`}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={open.onToggle}
            data-testid={`expand-button-${rowIndex}`}
          >
            {open.value ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell data-testid={`splitIndicator-${rowIndex}`}>{row.splitIndicator}</TableCell>
        <TableCell data-testid={`subjectPremium-${rowIndex}`}>
          {formatDollarAmount(row.subjectPremium)}
        </TableCell>
        <TableCell data-testid={`modifiedPremium-${rowIndex}`}>
          {formatDollarAmount(row.modifiedPremium)}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          sx={{
            paddingBottom: 0,
            paddingTop: 0,
            backgroundColor: open.value
              ? varAlpha(theme.vars.palette.grey['500Channel'], 0.4)
              : 'inherit',
          }}
          colSpan={6}
        >
          <Collapse in={open.value} timeout="auto" unmountOnExit>
            <UnitStatExposuresNestedTable rows={row.subRows} />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
